import { accountTranslations } from '../helpers/translations'

export const LogoUrl = GM_STATE?.assets?.logo?.dark ?? ''
export const isCustomerLoggedIn = GM_STATE?.customer?.logged ?? false
export const shoeWidthOptions = [
  {
    'AU/UK': 'C'
  },
  {
    'AU/UK': 'D'
  },
  {
    'AU/UK': 'E'
  },
  {
    'AU/UK': 'F'
  },
  {
    'AU/UK': 'G'
  },
  {
    'AU/UK': 'H'
  }
]
export const shoeSizeOptions = [
  {
    'AU/UK': '01'
  },
  {
    'AU/UK': '01.5'
  },
  {
    'AU/UK': '02'
  },
  {
    'AU/UK': '02.5'
  },
  {
    'AU/UK': '03'
  },
  {
    'AU/UK': '03.5'
  },
  {
    'AU/UK': '04'
  },
  {
    'AU/UK': '04.5'
  },
  {
    'AU/UK': '05'
  },
  {
    'AU/UK': '05.5'
  },
  {
    'AU/UK': '06'
  },
  {
    'AU/UK': '06.5'
  },
  {
    'AU/UK': '07'
  },
  {
    'AU/UK': '07.5'
  },
  {
    'AU/UK': '08'
  },
  {
    'AU/UK': '08.5'
  },
  {
    'AU/UK': '09'
  },
  {
    'AU/UK': '09.5'
  },
  {
    'AU/UK': '010'
  },
  {
    'AU/UK': '010.5'
  },
  {
    'AU/UK': '011'
  },
  {
    'AU/UK': '011.5'
  },
  {
    'AU/UK': '012'
  },
  {
    'AU/UK': '012.5'
  },
  {
    'AU/UK': '013'
  },
  {
    'AU/UK': '013.5'
  },
  {
    'AU/UK': '1'
  },
  {
    'AU/UK': '1.5'
  },
  {
    'AU/UK': '2'
  },
  {
    'AU/UK': '2.5'
  },
  {
    'AU/UK': '3'
  },
  {
    'AU/UK': '3.5'
  },
  {
    'AU/UK': '4'
  },
  {
    'AU/UK': '4.5'
  },
  {
    'AU/UK': '5'
  },
  {
    'AU/UK': '5.5'
  },
  {
    'AU/UK': '6'
  },
  {
    'AU/UK': '6.5'
  },
  {
    'AU/UK': '7'
  },
  {
    'AU/UK': '7.5'
  }
]

export const genderOptions = [
  {
    label: accountTranslations.form_labels.gender_labels.withheld,
    value: 'withheld'
  },
  {
    label: accountTranslations.form_labels.gender_labels.female,
    value: 'female'
  },
  {
    label: accountTranslations.form_labels.gender_labels.male,
    value: 'male'
  }
]

export const profileIcons = GM_STATE.metaobjects?.profile_icons ?? []
export const brandOptions = GM_STATE.metaobjects?.omneo_brands ?? []
export const sportOptions = GM_STATE.metaobjects?.omneo_sports ?? []
